import {
  MessageScroller,
  MessageScrollerButton,
  MessageScrollerContent,
  MessageScrollerItem,
  MessageScrollerProvider,
  MessageScrollerViewport
} from 'design-system';

import { useChatState } from '../../../state/useChat';
import MessageComponent from '../Messages/MessageComponent';
import NoMessagesScreen from '../NoMessagesScreen/NoMessagesScreen';

const Chat = () => {
  const { conversationId, messages } = useChatState();

  if (messages.length === 0) return <NoMessagesScreen />;

  return (
    <MessageScrollerProvider
      autoScroll
      key={conversationId}
      defaultScrollPosition='last-anchor'
    >
      <MessageScroller className='flex-1 bg-gx-main-background'>
        <MessageScrollerViewport>
          <MessageScrollerContent className='mx-auto w-full  gap-7 px-6 py-7'>
            {messages.map((msg, index) => (
              <MessageScrollerItem
                key={msg.id}
                messageId={msg.id}
                scrollAnchor={msg.role === 'user'}
              >
                <MessageComponent
                  index={index}
                  msg={msg}
                />
              </MessageScrollerItem>
            ))}
          </MessageScrollerContent>
        </MessageScrollerViewport>
        <MessageScrollerButton className='border-gx-border bg-gx-tile-dark shadow-lg hover:bg-gx-response' />
      </MessageScroller>
    </MessageScrollerProvider>
  );
};

export default Chat;
